
import type { PublisherAppConfig } from "@/common/types/app-config";

const config: PublisherAppConfig = {
  featureGuestModeEnabled: false,
  featureHeaderEnabled: false,
  featureSplashLogoEnabled: false,
  featureLoginLogoEnabled: false,
  authMethod: {
    featureMacAddressLoginEnabled: true,
    featureRefreshTokenLoginEnabled: false,
  },
  signInMethod: {
    oktaEnabled: false,
    codeEnabled: false,
    formEnabled: false,
  },
  isEnabledServiceLinkHeader: false,
  isTimeFormat12: true,
  linkItems:{
    'main':{
      'client': [],
      'guest': [],
    },
    'settings':{
      'client': [],
      'guest': [],
    },
  },
  devMode: {
    sections: ['api'],
  },
  mainPage: "guide",
  lineViewRows: {
    'home' : [],
    'vod' : [],
  },
  guideConfig:{
    featureChannelLogoOriginalEnabled: true,
    featureRedirectToGuidefromPlayerEnabled: true,
    isDynamicOpacityChannelLogo: false,
    featureBtnWatchEnabled: true,
    featureGuideRestartBtnsEnabled: true,
    featureGuideFilterEnabled: false,
    featureGuideControlsEnabled: true,
    featureGuideDetailPageEnabled: false,
    featureMoveLeftRightEnabled: false,
    featureStartFocusCanvasEnabled: true,
    featurePrevProgramEnabled: false,
    featureScrollbarEnabled: true,
    channelsPageSize: 24,
    featureUpdateViewportChannelsEnabled: false
  },
  playerConfig:{
    topPanel: {
      isEnabledChannelNumber: true,
      isEnabledChannelImage: true,
      isEnabledCallSign: false,
      isEnabledProgramName: false,
    },
    controlsPanel: {
      isEnabledProgramName: true,
      isEnableAutoCloseInfoAfterUpdateProgram: false,
    }
  },
  orderBy: {
    getVodInternalContent: "name ASC"
  },
  login: {
    welcomeScreenEnabled: false
  },
}

export default defineAppConfig({...config})
